module.exports = __webpack_public_path__ + "source-sans-pro-v10-latin-ext_latin-regular.196a1150da7aea619633.woff2";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-regular.woff2
// module id = ../../../../../src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-regular.woff2
// module chunks = styles